import store from "./store";

class Notifications {
    static TYPES = {
        ERROR:'error',
        WARNING:'warning',
        NOTIFICATION:'notification',
        RELOAD:'reload',
        WARNING_TEMP:'warning too high temperature'
    };

    static add(type, title, content) {
        store.commit('pushNewNotification', {type, title, content});
    }
}

export {Notifications};